module.exports = __webpack_public_path__ + "img/mcc.19e18684.png";